import styled from 'styled-components';

export default styled.div`
  margin-top: 3rem;
  float: right;
  & > .buttonsWrapper {
    display: table;
    & button {
      color: #fff;
      background: rgba(255,255,255,.4);
      font-size: 2rem;
      margin: 0 .1rem 0 1.5rem;
      outline: none;
      cursor: pointer;
      box-sizing: border-box;
      border: .4rem solid transparent;
      padding: .5rem 1rem;
      float: right;
      &:hover {
        background: #fff;
        & > i, & > p {
          color: #020100;
        }
      }
      &.activeItem, &:hover {
        border: .4rem solid #ea1d5d;
        background: #fff;
        & > i, & > p {
          color: #020100;
        }
      }
      & > i {
        margin: 0 .5rem;
        font-size: 2rem;
        float: right;
      }
      & > p {
        float: right;
        margin: .35rem 0;
      }
    }
  }
  & > p {
    color: #fff;
    font-size: 2rem;
    margin: 0 .1rem 1rem 0;
  }
`;
